import { render, staticRenderFns } from "./TabsMobile.vue?vue&type=template&id=58ce3974&scoped=true&"
import script from "./TabsMobile.vue?vue&type=script&lang=js&"
export * from "./TabsMobile.vue?vue&type=script&lang=js&"
import style0 from "./TabsMobile.vue?vue&type=style&index=0&id=58ce3974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ce3974",
  null
  
)

export default component.exports